import React, { useState, useEffect } from "react";

const FooterCookie = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if the session cookie exists
    const cookiesAccepted = document.cookie
      .split("; ")
      .find((row) => row.startsWith("cookies_accepted="));
    if (!cookiesAccepted) {
      setShowBanner(true); // Show banner if no session cookie is found
    }
  }, []);

  const handleAccept = () => {
    setShowBanner(false);
    // Set a session cookie (no `max-age` or `expires` makes it a session cookie)
    document.cookie = "cookies_accepted=true; path=/; max-age=86400;";
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full bg-white shadow-lg p-4 flex flex-col sm:flex-row sm:justify-between sm:items-center z-50">
      <p className="text-sm text-gray-700 mb-2 sm:mb-0 px-4 text-center sm:text-left">
        เว็บไซต์ของเราใช้คุกกี้เพื่อเพิ่มประสิทธิภาพ และประสบการณ์ที่ดีในการใช้เว็บไซต์ของคุณ อ่านรายละเอียดเพิ่มเติมได้ที่{" "}
        <a href="/policy/privacynotice" className="text-blue-600 hover:underline">
          นโยบายความเป็นส่วนตัว
        </a>{" "}
        และ{" "}
        <a href="/policy/cookieconsent" className="text-blue-600 hover:underline">
          นโยบายคุกกี้
        </a>
      </p>
      <button
        className="bg-red-600 text-white px-4 py-2 rounded-md text-sm hover:bg-red-700 focus:outline-none w-full sm:w-auto mx-auto sm:mx-4"
        onClick={handleAccept}
      >
        ยอมรับ
      </button>
    </div>
  );
};

export default FooterCookie;
